export namespace WithdrawMethodId {
  export const Crypto = 1n;
  export const BetterbroBrazillianPix = 2n;
  export const PixtopayBrazillianPix = 3n;
  export const BetterbroMexicanSpei = 4n;
  export const BetterbroArgentineBankTransfer = 5n;
  export const BetterbroIndianImps = 6n;
  export const PayGamesIndiaUpi = 7n;
  export const PayGamesSingaporePayNow = 8n;
  export const PayGamesIndonesiaQris = 9n;
  export const PayGamesSouthAfrica = 10n;
  export const PayGamesNigeria = 11n;
  export const SevenPay = 12n;
}

export type WithdrawMethodIdType =
  (typeof WithdrawMethodId)[keyof typeof WithdrawMethodId];
